// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remark[data-v-6d07ade4]{font-size:14px;padding-top:10px;line-height:30px;color:#666}", ""]);
// Exports
module.exports = exports;
